import { render, staticRenderFns } from "./company-detail.component.html?vue&type=template&id=f25d48dc&scoped=true&"
import script from "./company-detail.component.ts?vue&type=script&lang=ts&"
export * from "./company-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./company-detail.component.scss?vue&type=style&index=0&id=f25d48dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d48dc",
  null
  
)

export default component.exports